import React from 'react';
import PropTypes from 'prop-types';

const ErrorMessage = ({ message }) => {
    if (!message) {
        return null;
    }

    return <p className="messaging -error -subtle">{message}</p>;
};

ErrorMessage.propTypes = {
    message: PropTypes.string.isRequired,
};

export default ErrorMessage;
